import React from "react";
import { useNavigate } from "react-router-dom";
import { LEGAL_IDENTITY, publicOperatorDescription } from "../config/legalIdentity";
import "./legal.css";

export default function LegalDocumentPage({ title, subtitle, version = "2026-08-17.2", sections }) {
  const navigate = useNavigate();
  return <div className="zuno-legal-document">
    <header className="zuno-legal-header"><button onClick={() => navigate(-1)}>← Voltar</button><b>ZUNO</b><span>Documento jurídico</span></header>
    <main className="zuno-legal-main">
      <section className="zuno-legal-hero"><small>VERSÃO {version}</small><h1>{title}</h1><p>{subtitle}</p><div className="zuno-legal-warning"><strong>Responsável pela oferta:</strong> {publicOperatorDescription()}<br />Canal de privacidade: <a href={`mailto:${LEGAL_IDENTITY.privacyContact}`}>{LEGAL_IDENTITY.privacyContact}</a>. A publicação do aplicativo não libera corridas em municípios ainda sujeitos à revisão regulatória.</div></section>
      {sections.map((section, index) => <section className="zuno-legal-section" key={section.title}>
        <small>{String(index + 1).padStart(2, "0")}</small><h2>{section.title}</h2>
        {(section.paragraphs || []).map((paragraph, item) => <p key={item}>{paragraph}</p>)}
        {section.items && <ul>{section.items.map((item) => <li key={item}>{item}</li>)}</ul>}
      </section>)}
      <footer className="zuno-legal-footer">Zuno · operação inicial por pessoa natural · Privacidade: {LEGAL_IDENTITY.privacyContact} · Suporte: {LEGAL_IDENTITY.supportEmail}</footer>
    </main>
  </div>;
}
